import styled from "styled-components"

import { ReactComponent as CloseIcon } from "assets/svg/icon-close.svg"
import { ReactComponent as SettingsIcon } from "assets/svg/icon-settings.svg"

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 16px 16px 20px;
`

const Title = styled.h3`
  flex: 1;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.27px;
  color: var(--text-primary);
  margin: 0;
`

const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  &:hover {
    opacity: 0.8;
  }

  svg {
    width: 24px;
    height: 24px;
  }
`

interface NotificationCenterModalHeaderProps {
  onOpenSettings: () => void
  onClose: () => void
}

export const NotificationCenterModalHeader = ({ onOpenSettings, onClose }: NotificationCenterModalHeaderProps) => {
  return (
    <Header>
      <Title>Notification Center</Title>
      <IconButton onClick={onOpenSettings} aria-label="Settings">
        <SettingsIcon />
      </IconButton>
      <IconButton onClick={onClose} aria-label="Close">
        <CloseIcon />
      </IconButton>
    </Header>
  )
}
